import { render, staticRenderFns } from "./MamaFindingTable.vue?vue&type=template&id=4e2427ca&"
import script from "./MamaFindingTable.vue?vue&type=script&lang=js&"
export * from "./MamaFindingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports